import React, { useEffect, useState } from "react";
import { connect, useDispatch, useSelector } from "react-redux";

import { login, signFailed, signUpSuccess } from "../../redux/actions/auth";

import ModalComponent from "../../components/Modal";

import { Link, useHistory } from "react-router-dom";
import sha512 from "crypto-js/sha512";
import TextField from "@mui/material/TextField";
// import SelectLabels from "../../components/SelectLabels";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import authReducer from "../../redux/reducers";
import { toast, ToastContainer } from "react-toastify";
import LoginLoader from "../../components/LoginLoader";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import {
  IconButton,
  InputAdornment,
  ThemeProvider,
  createTheme,
  Backdrop,
} from "@mui/material";
import { useFormik } from "formik";
import * as yup from "yup";
import ReCAPTCHA from "react-google-recaptcha";
import Recaptcha from "react-recaptcha";
import Loader from "../../components/Loader";
import firebird from "../../assets/images/firebird.png";
import PersonIcon from "@mui/icons-material/Person";
import LockIcon from "@mui/icons-material/Lock";
import AbcIcon from "@mui/icons-material/Abc";
import EmailIcon from "@mui/icons-material/Email";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import axios from "axios";
import { xCheckSumIdGernator } from "../../helper/helper";
import { SHA512 } from "crypto-js";
import Swal from "sweetalert2";

const customId1 = "custom-id-yess";

export default function ContactUs() {
  const history = useHistory();
  const [open, setOpen] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [value, setValue] = React.useState(0);
  const [verified, setVerified] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const handleMouseDownPassword = () => setShowPassword(!showPassword);
  const handleClickShowPassword = () => setShowPassword(!showPassword);

  const [statusMann, setStatusMann] = useState();

  const theme = createTheme({
    components: {
      MuiFormLabel: {
        styleOverrides: {
          asterisk: { color: "red" },
        },
      },
    },
  });

  const handleChange = (event) => {
    setValue(event.target.value);
  };

  const statusMan = useSelector((state) => state.authReducer.Signinstatus);

  // console.log(statusMan, statusMan == true);

  const dispatch = useDispatch();

  const validationSchema = yup.object({
    // .matches(/^(\S+$)/g, "* This field cannot contain  blankspaces"),

    name: yup
      .string("Enter your Name")
      .min(2, "Name should be of minimum 2 characters length")
      .required("Name is required"),
    email: yup
      .string()
      .email("E-Mail must be valid")
      .max(255)
      .required("E-Mail  is required"),
    phoneNumber: yup
      .number("Enter  Phone Number ")
      .min(
        1000000000,
        "Phone Number  should be of minimum 10 characters length"
      )
      .max(
        10000000000,
        "Phone Number  should be of maximum 11 characters length"
      )
      .required("Phone is required"),
    subject: yup
      .string("Enter your Subject")
      .min(2, "Subject should be of minimum 3 characters length")
      .required("Subject is required"),
    message: yup
      .string("Enter your Message")
      .min(2, "Message should be of minimum 3 characters length")
      .required("Message is required"),
  });

  const formik = useFormik({
    initialValues: {
      name: "",
      email: "",
      phoneNumber: "",
      subject: "",
      message: "",
    },

    onReset: (initialValues) => ({
      values: { initialValues },
    }),
    validateOnChange: true,

    validationSchema: validationSchema,
    onSubmit: async (values) => {
      try {
        setOpen(true);
        const generator = Math.floor(Math.random() * 100000000);
        const allValues = `${values.phoneNumber}${generator}54IzSRi`;
        const allValuesHashed = sha512(allValues).toString();
        // console.log({ allValues, generator });
        // console.log({ allValuesHashed });

        const res = await axios.post(
          `${process.env.REACT_APP_COMMON_API}/admin/v1/lead/generation/add`,
          {
            name: values.name,
            email: values.email,
            msisdn: values.phoneNumber,
            subject: values.subject,
            message: values.message,
            requestId: generator,
            isDebug: false,
          },
          {
            headers: {
              "X-CHECKSUM-ID": allValuesHashed,
            },
          }
        );

        if (res.data.statusDescription.statusCode == 200) {
          setOpen(false);
          await setTimeout(() => {
            // toast.success("Your query has been Submitted !!", {
            //   theme: "colored",
            // });
            Swal.fire({
              icon: "success",
              // title: "Oops...",
              text:"Your query has been Submitted !!",
              // footer: '<a href="">Why do I have this issue?</a>'
            });
          }, 100);
        } else {
          setOpen(false);
          await setTimeout(() => {
            // toast.error(res.data.statusDescription.description, {
            //   theme: "colored",
            // });
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text:res.data.statusDescription.description,
              // footer: '<a href="">Why do I have this issue?</a>'
            });
          }, 100);
        }
      } catch (error) {
        setOpen(false);
        // console.log(error);

        // await toast.error("Something Went Wrong ! Please check your network", {
        //   theme: "colored",
        //   customId1,
        // });
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text:"Something Went Wrong ! Please check your network",
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      }
    },
  });
  return (
    <>
      <main class="main-content my-aut lgin_cntnt position-relative w-auto  border-radius-l  ">
        <Backdrop
          sx={{
            transform: "translateZ(0)",
            color: "#fff",
            zIndex: (theme) => theme.zIndex.drawer + 1,
          }}
          open={open}
          // onClick={handleClose}
        >
          <Loader />
        </Backdrop>
        <ThemeProvider theme={theme}>
          <ToastContainer autoClose={5000} />

          <button
            type="button"
            class="btn btn-primary"
            data-bs-toggle="modal"
            data-bs-target="#exampleModal"
            data-bs-whatever="@mdo"
          >
            Open modal for contact
          </button>

          <div
            class="modal fade"
            id="exampleModal"
            tabindex="-1"
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
          >
            <div class="modal-dialog">
              <div class="modal-content">
                <div class="modal-header">
                  <h1 class="modal-title fs-5" id="exampleModalLabel">
                    New message
                  </h1>
                  <button
                    type="button"
                    class="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  ></button>
                </div>
                <div class="modal-body">
                  <form>
                    <div class="mb-3">
                      <label for="recipient-name" class="col-form-label">
                        Recipient:
                      </label>
                      <input
                        type="text"
                        class="form-control"
                        id="recipient-name"
                      />
                    </div>
                    <div class="mb-3">
                      <label for="message-text" class="col-form-label">
                        Message:
                      </label>
                      <textarea
                        class="form-control"
                        id="message-text"
                      ></textarea>
                    </div>
                  </form>
                </div>
                <div class="modal-footer">
                  <button
                    type="button"
                    class="btn btn-secondary"
                    data-bs-dismiss="modal"
                  >
                    Close
                  </button>
                  <button type="button" class="btn btn-primary">
                    Send message
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div class="container-fluid px-0">
            <div class="row d-md-flex d-none h_vh align-items-cente mx-0">
              <div class="col-md-7 bg_18 d-flex">
                <div class="ps_8 my-auto py_5">
                  <img src={firebird} class="img-fluid d-block mx-auto" />
                  <p class="text-center m-0 mt-4 fw-bold">
                    FIREBIRD, An Omni Channel Solution which broadens
                    Communication channels to Telecom operators. Its an
                    integrated platform to meet the Business requirements with
                    respect to Messaging solutions and Voice solutions.
                  </p>
                </div>
              </div>
              <div
                class="col-md-5 d-flex align-items-center bg_8 p-4"
                style={{ padding: "3.5rem" }}
              >
                <div class="w-100">
                  <form onSubmit={formik.handleSubmit}>
                    <div class="">
                      <div class="">
                        <div class="text-center">
                          <EmailIcon
                            style={{
                              fontSize: "20px",

                              color: "white",
                              border: "0.5px solid #0083AD",
                              borderRadius: "30px",
                              backgroundColor: "#0083AD",
                            }}
                          />
                        </div>
                        <div class="text-center mt-2">
                          <span class="d-inline-block text-capitalize">
                            Contact Us
                          </span>
                        </div>
                      </div>
                      <div class="my-4">
                        <div class="my-4">
                          <div className=" d-flex">
                            <div className="me-2 mt-3">
                              <AbcIcon style={{ fontSize: "17px" }} />
                            </div>
                            <TextField
                              required
                              className="w-100"
                              label="Name"
                              name="name"
                              variant="standard"
                              size="small"
                              value={formik.values.name}
                              onChange={formik.handleChange}
                              error={
                                formik.touched.name &&
                                Boolean(formik.errors.name)
                              }
                              helperText={
                                formik.touched.name && formik.errors.name
                              }
                            />
                          </div>
                        </div>

                        <div class="my-4">
                          <div className="d-flex">
                            <div className="me-2 mt-3">
                              <EmailIcon style={{ fontSize: "17px" }} />
                            </div>
                            <TextField
                              required
                              className="w-100"
                              label="E-mail"
                              name="email"
                              variant="standard"
                              type="email"
                              size="small"
                              value={formik.values.email}
                              onChange={formik.handleChange}
                              error={
                                formik.touched.email &&
                                Boolean(formik.errors.email)
                              }
                              helperText={
                                formik.touched.email && formik.errors.email
                              }
                            />
                          </div>
                        </div>

                        <div class=" my-4">
                          <div className="d-flex">
                            <div className="me-2 mt-3">
                              <LocalPhoneIcon style={{ fontSize: "17px" }} />
                            </div>
                            <TextField
                              required
                              className="w-100"
                              label="Phone Number"
                              name="phoneNumber"
                              variant="standard"
                              size="small"
                              type="number"
                              onInput={(e) => {
                                e.target.value = Math.max(
                                  0,
                                  parseInt(e.target.value)
                                )
                                  .toString()
                                  .slice(0, 8);
                              }}
                              value={formik.values.phoneNumber}
                              onChange={formik.handleChange}
                              error={
                                formik.touched.phoneNumber &&
                                Boolean(formik.errors.phoneNumber)
                              }
                              helperText={
                                formik.touched.phoneNumber &&
                                formik.errors.phoneNumber
                              }
                            />
                          </div>
                        </div>
                        <div class="my-4">
                          <div className="d-flex">
                            <div className="me-2 mt-3">
                              <EmailIcon style={{ fontSize: "17px" }} />
                            </div>
                            <TextField
                              required
                              className="w-100"
                              label="Subject"
                              name="subject"
                              variant="standard"
                              type="text"
                              size="small"
                              value={formik.values.subject}
                              onChange={formik.handleChange}
                              error={
                                formik.touched.subject &&
                                Boolean(formik.errors.subject)
                              }
                              helperText={
                                formik.touched.subject && formik.errors.subject
                              }
                            />
                          </div>
                        </div>
                        <div class="my-4">
                          <div className="d-flex">
                            <div className="me-2 mt-3">
                              <EmailIcon style={{ fontSize: "17px" }} />
                            </div>
                            <TextField
                              required
                              className="w-100"
                              label="Message"
                              name="message"
                              variant="standard"
                              type="text"
                              size="small"
                              value={formik.values.message}
                              onChange={formik.handleChange}
                              error={
                                formik.touched.message &&
                                Boolean(formik.errors.message)
                              }
                              helperText={
                                formik.touched.message && formik.errors.message
                              }
                            />
                          </div>
                        </div>
                        <button
                          type="submit"
                          class="btn bg-gradient-primary register_grad d-block w-100 my-4"
                        >
                          Submit
                        </button>
                        <div className="row">
                          <div className="d-flex justify-content-between">
                            <div className="text-start fw-bold">
                              <a
                                href="#"
                                onClick={formik.handleReset}
                                class="text-capitalize link-info"
                              >
                                Reset
                              </a>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div
                              class="text-end  fw-bold link-info"
                              id="sign_up_in"
                            >
                              <Link to="/" class="text-capitalize">
                                Log In
                              </Link>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </ThemeProvider>
        <div class="d-md-none d-flex bg_18 h_vh">
          <div class="w-100 my-auto px_15 py-5">
            <div class="bg_8 p-4">
              <div class="w-100">
                <form onSubmit={formik.handleSubmit}>
                  <div class="">
                    <div class="">
                      <div class="text-center">
                        <i class="fas fa-lock lock p-2"></i>
                      </div>
                      <div class="text-center mt-2">
                        <span class="d-inline-block text-capitalize">
                          Contact Us
                        </span>
                      </div>
                    </div>
                    <div class="my-4">
                      <div class="my-4">
                        <div className="d-flex">
                          <div className="me-2 mt-3">
                            <PersonIcon style={{ fontSize: "17px" }} />
                          </div>
                          <TextField
                            required
                            className="w-100"
                            label="Name"
                            name="username"
                            variant="standard"
                            size="small"
                            // type="email"

                            value={formik.values.username}
                            onChange={formik.handleChange}
                            error={
                              formik.touched.username &&
                              Boolean(formik.errors.username)
                            }
                            helperText={
                              formik.touched.username && formik.errors.username
                            }
                          />
                        </div>
                      </div>

                      <div class="my-4">
                        <div className=" d-flex">
                          <div className="me-2 mt-3">
                            <AbcIcon style={{ fontSize: "17px" }} />
                          </div>
                          <TextField
                            required
                            className="w-100"
                            label="Name"
                            name="name"
                            variant="standard"
                            size="small"
                            value={formik.values.name}
                            onChange={formik.handleChange}
                            error={
                              formik.touched.name && Boolean(formik.errors.name)
                            }
                            helperText={
                              formik.touched.name && formik.errors.name
                            }
                          />
                        </div>
                      </div>

                      <div class="my-4">
                        <div className="d-flex">
                          <div className="me-2 mt-3">
                            <EmailIcon style={{ fontSize: "17px" }} />
                          </div>
                          <TextField
                            required
                            className="w-100"
                            label="E-mail"
                            name="email"
                            variant="standard"
                            type="email"
                            size="small"
                            value={formik.values.email}
                            onChange={formik.handleChange}
                            error={
                              formik.touched.email &&
                              Boolean(formik.errors.email)
                            }
                            helperText={
                              formik.touched.email && formik.errors.email
                            }
                          />
                        </div>
                      </div>

                      <div class=" my-4">
                        <div className="d-flex">
                          <div className="me-2 mt-3">
                            <LocalPhoneIcon style={{ fontSize: "17px" }} />
                          </div>
                          <TextField
                            required
                            className="w-100"
                            label="Phone Number"
                            name="phoneNumber"
                            variant="standard"
                            size="small"
                            type="number"
                            onInput={(e) => {
                              e.target.value = Math.max(
                                0,
                                parseInt(e.target.value)
                              )
                                .toString()
                                .slice(0, 10);
                            }}
                            value={formik.values.phoneNumber}
                            onChange={formik.handleChange}
                            error={
                              formik.touched.phoneNumber &&
                              Boolean(formik.errors.phoneNumber)
                            }
                            helperText={
                              formik.touched.phoneNumber &&
                              formik.errors.phoneNumber
                            }
                          />
                        </div>
                      </div>
                      <div class="my-4">
                        <div className="d-flex">
                          <div className="me-2 mt-3">
                            <EmailIcon style={{ fontSize: "17px" }} />
                          </div>
                          <TextField
                            required
                            className="w-100"
                            label="Subject"
                            name="subject"
                            variant="standard"
                            type="text"
                            size="small"
                            value={formik.values.subject}
                            onChange={formik.handleChange}
                            error={
                              formik.touched.subject &&
                              Boolean(formik.errors.subject)
                            }
                            helperText={
                              formik.touched.subject && formik.errors.subject
                            }
                          />
                        </div>
                      </div>
                      <div class="my-4">
                        <div className="d-flex">
                          <div className="me-2 mt-3">
                            <EmailIcon style={{ fontSize: "17px" }} />
                          </div>
                          <TextField
                            required
                            className="w-100"
                            label="Message"
                            name="message"
                            variant="standard"
                            type="text"
                            size="small"
                            value={formik.values.message}
                            onChange={formik.handleChange}
                            error={
                              formik.touched.message &&
                              Boolean(formik.errors.message)
                            }
                            helperText={
                              formik.touched.message && formik.errors.message
                            }
                          />
                        </div>
                      </div>
                      <button
                        type="submit"
                        class="btn bg-gradient-primary register_grad d-block w-100 my-4"
                      >
                        Submit
                      </button>
                      <div className="row">
                        <div className="d-flex justify-content-between">
                          <div className="text-start fw-bold">
                            <a
                              href="#"
                              onClick={formik.handleReset}
                              class="text-capitalize link-info"
                            >
                              Reset
                            </a>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div
                            class="text-end  fw-bold link-info"
                            id="sign_up_in"
                          >
                            <Link to="/" class="text-capitalize">
                              Log In
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
}
